module.exports = __webpack_public_path__ + "img/cheatsheet_icon_myprojects_2x.ba44d9e4.png";